import Raven from 'raven-js';

const LIBRARY_NAME = 'ui-universal-auth';

type CaptureExceptionOptions = NonNullable<
  Parameters<typeof Raven.captureException>[1]
>;

type CaptureMessageOptions = NonNullable<
  Parameters<typeof Raven.captureMessage>[1]
>;

export function captureException(
  error: Error,
  options: CaptureExceptionOptions = {}
): void {
  Raven.captureException(error, {
    ...options,
    tags: { ...options.tags, library_name: LIBRARY_NAME },
  });
}

export function captureMessage(
  message: string,
  options: CaptureMessageOptions = {}
): void {
  Raven.captureMessage(message, {
    ...options,
    tags: { ...options.tags, library_name: LIBRARY_NAME },
  });
}

// Raven only keeps `cause` when it is a real Error, so normalize the unknown
// values that reach our catch blocks before wrapping them.
export function toError(value: unknown): Error {
  return value instanceof Error ? value : new Error(String(value));
}
